import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import type { CommissionProgramConsentNode, CommissionProgramConsentStatus } from "./types";

export interface CommissionProgramConsentsQueryResponse {
  commissionProgramConsents: {
    nodes: CommissionProgramConsentNode[];
    totalCount: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
  };
}

export interface CommissionProgramConsentsQueryVariables extends PaginationVariables {
  campaignId?: string;
  crmPersonId?: string;
  status?: CommissionProgramConsentStatus;
}

export const COMMISSION_PROGRAM_CONSENTS_QUERY: TypedDocumentNode<
  CommissionProgramConsentsQueryResponse,
  CommissionProgramConsentsQueryVariables
> = gql`
  query CommissionProgramConsents(
    $campaignId: ID
    $crmPersonId: ID
    $status: BackofficeCommissionProgramConsentStatus
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    commissionProgramConsents(
      campaignId: $campaignId
      crmPersonId: $crmPersonId
      status: $status
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      nodes {
        id
        commissionCampaignId
        crmPersonId
        attributionModel
        ownership
        crmFacilityId
        facilityName
        startsAt
        endsAt
        startsOn
        endsOn
        status
        person {
          id
          displayName
          pgaId
        }
        campaign {
          id
          editionYear
          partner {
            id
            name
          }
          program {
            id
            name
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export interface CommissionProgramConsentQueryResponse {
  commissionProgramConsent: CommissionProgramConsentNode | null;
}

export interface CommissionProgramConsentQueryVariables {
  id: string;
}

export const COMMISSION_PROGRAM_CONSENT_QUERY: TypedDocumentNode<
  CommissionProgramConsentQueryResponse,
  CommissionProgramConsentQueryVariables
> = gql`
  query CommissionProgramConsent($id: ID!) {
    commissionProgramConsent(id: $id) {
      id
      commissionCampaignId
      crmPersonId
      attributionModel
      ownership
      crmFacilityId
      facilityName
      startsAt
      endsAt
      startsOn
      endsOn
      status
      person {
        id
        displayName
        pgaId
      }
      campaign {
        id
        editionYear
        partner {
          id
          name
        }
        program {
          id
          name
        }
      }
    }
  }
`;
